import { Pagination } from '@ffw/randstad-shared-components/build';
import UI from '@UI/hoc/UI';

export default UI(Pagination)();
